import { render, staticRenderFns } from "./DisplayNameBox.vue?vue&type=template&id=7381804f&"
import script from "./DisplayNameBox.vue?vue&type=script&lang=ts&"
export * from "./DisplayNameBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports